module.exports = __webpack_public_path__ + "img/41.913e604e.png";